/** # 根级别的 action */
import { ActionContext } from 'vuex'
import { RootState } from './interfaces'
const actions = {
  asyncIncrement({ commit }: ActionContext<RootState, RootState>) {
    setTimeout(() => {
      commit('increment', 10)
    }, 200)
  }
}

export default actions
